// Adris Davis — Executive Personal Brand Site Data

export const siteConfig = {
  name: "ADRIS DAVIS",
  title: "Entrepreneur & Author",
  tagline: "Empowering entrepreneurs through elite tactics and financial mastery.",
  email: "info@adrisdavis.com",
  amazonAuthor: "https://www.amazon.com/stores/Adris-Davis/author/B0CD6FNMDY",
  copyright: `\u00a9 ${new Date().getFullYear()} Adris Davis. All rights reserved.`,
};

export const navLinks = [
  { label: "Home", path: "/" },
  { label: "Books", path: "/books" },
  { label: "Adris Davis Realty", path: "/realty" },
  { label: "About", path: "/about" },
  { label: "Press", path: "/press" },
  { label: "Contact", path: "/contact" },
];

export const initiativeLinks = [
  { label: "Social Media Amber Alert", path: "/initiatives/amber-alert" },
  { label: "Team Hustle \u2013 Coaching & Mentorship", path: "/initiatives/team-hustle" },
  { label: "Prestigious Travel Club Foundation", path: "/initiatives/ptc" },
  { label: "Night Owl Entrepreneurs", path: "/initiatives/night-owl" },
  { label: "Feeding the Community", path: "/initiatives/feeding-community" },
  { label: "Cars for Families", path: "/initiatives/cars-for-families" },
  { label: "Speaking & Workshops", path: "/initiatives/speaking" },
];

export const aboutBio = {
  headline: "About Adris Davis",
  headshot: "https://customer-assets.emergentagent.com/job_wanderlust-club/artifacts/usgmm81i_image.png",
  carsImage: "https://customer-assets.emergentagent.com/job_wanderlust-club/artifacts/cahwv7hx_image.png",
  bmwImage: "https://customer-assets.emergentagent.com/job_wanderlust-club/artifacts/btsuczmj_image.png",
  body: `Adris Davis is a sales leader, entrepreneur, and author with more than two decades of real-world experience building businesses, leading high-performance teams, and mastering the art of persuasion.

His career began in the car industry in 1997, where he quickly distinguished himself as a top performer, earning multiple Salesman of the Month awards. What started as a hands-on introduction to sales evolved into a lifelong pursuit of excellence in communication, influence, and leadership.

Over the years, Adris has held key leadership roles within major hospitality and vacation ownership organizations, including Wyndham Resorts and Diamond Resorts. Following the $1.4 billion acquisition of Diamond Resorts by Hilton Grand Vacations, he continued to lead at a high level, serving as Director of Sales and driving consistent results in competitive environments.

Beyond corporate leadership, Adris is the founder behind multiple business ventures focused on financial empowerment, sales development, and consumer education. His work is centered on helping individuals navigate complex financial situations, build sustainable income, and develop the mindset required to succeed at a high level.

As an author, Adris has published several books covering credit, entrepreneurship, and advanced sales strategy.

His approach blends practical experience with analytical thinking\u2014breaking down complex concepts into actionable strategies that produce results.

At his core, Adris Davis is focused on one mission: equipping people with the tools, knowledge, and confidence to take control of their financial future and operate at an elite level in business and in life.`,
  bookList: [
    "From 350 - 850: A Journey to Perfect Credit",
    "Elite Sales Tactics for Elite Sales Professionals",
    "From Zero to Success",
    "Embracing the Analytical Mind",
  ],
};

export const books = [
  {
    id: 1,
    title: "Your First 3 Years",
    subtitle: "A Comprehensive Guide for Vacation Sales Professionals",
    description: "A transformative handbook equipping aspiring sales professionals with the tools, knowledge, and mindset to thrive. Covers mastering sales techniques, building authentic connections, time management, overcoming objections, and generating referrals.",
    cover: "https://m.media-amazon.com/images/I/81mRwTWwFAL._AC_CR0%2C0%2C0%2C0_SX480_SY360_.jpg",
    amazonUrl: "https://www.amazon.com/Your-First-Years-Comprehensive-Professionals-ebook/dp/B0CDC148XH",
    price: "$13.99",
    format: "Kindle & Paperback",
    badge: "Most Popular",
  },
  {
    id: 2,
    title: "Elite Sales Tactics for Elite Sales Professionals",
    subtitle: "The Art and Science of Persuasion",
    description: "A comprehensive guide to mastering the art of sales. Covers prospecting, building genuine connections, needs analysis, the psychology of selling, advanced closing techniques, upselling strategies, and building lasting customer relationships.",
    cover: "https://m.media-amazon.com/images/I/61s5583Ee9L._AC_CR0%2C0%2C0%2C0_SX480_SY360_.jpg",
    amazonUrl: "https://www.amazon.com/ELITE-SALES-TACTICS-PROFESSIONALS-PERSUASION/dp/B0CCZSZHL5",
    price: "$14.99",
    format: "Paperback",
    badge: "5.0 \u2605",
  },
  {
    id: 3,
    title: "From Zero to Success",
    subtitle: "Building a Thriving Business with No Money",
    description: "Living proof that building a business with no money is not only possible but can lead to massive success. A blueprint for your own entrepreneurial odyssey\u2014requiring courage, creativity, and unwavering dedication.",
    cover: "https://m.media-amazon.com/images/I/81Rx8BJjC6L._AC_CR0%2C0%2C0%2C0_SX480_SY360_.jpg",
    amazonUrl: "https://www.amazon.com/Zero-Success-Building-Thriving-Business-ebook/dp/B0CD7GPVZF",
    price: "$9.99",
    format: "Kindle",
    badge: "5.0 \u2605",
  },
  {
    id: 4,
    title: 'From "350 \u2013 850"',
    subtitle: 'A Journey to "Perfect Credit"',
    description: "A comprehensive guide that empowers readers to achieve financial freedom and build a solid credit foundation. Covers credit scores, payment history, credit utilization, disputing errors, and long-term credit management strategies.",
    cover: "https://m.media-amazon.com/images/I/71XOHWmvUwL._AC_CR0%2C0%2C0%2C0_SX480_SY360_.jpg",
    amazonUrl: "https://www.amazon.com/350-850-Journey-Perfect-Credit-ebook/dp/B0CD5JZGNL",
    price: "$10.99",
    format: "Kindle & Paperback",
    badge: "5.0 \u2605",
  },
  {
    id: 5,
    title: "Embracing the Analytical Mind",
    subtitle: "An Analytical Guide to Sales Excellence",
    description: "A transformative guide bridging analytical acumen and persuasive sales techniques. Offers a blueprint for harnessing analytical thinking\u2014from data-driven pitching to navigating objections with precision.",
    cover: "https://m.media-amazon.com/images/I/61TZpWT964L._AC_CR0%2C0%2C0%2C0_SX480_SY360_.jpg",
    amazonUrl: "https://www.amazon.com/Embracing-Analytical-Mind-guide-Excellence/dp/B0CGKV41VF",
    price: "$15.95",
    format: "Paperback",
    badge: null,
  },
];

export const quickLinks = [
  { label: "Books", path: "/books" },
  { label: "About", path: "/about" },
  { label: "Initiatives", path: "/initiatives" },
  { label: "Contact", path: "/contact" },
];

export const projectStatus = {
  nextBookRelease: "Q4 2025 \u2014 New title in development",
  currentFocus: "Manuscript review & speaking engagement pipeline",
};

export const initiativesContent = {
  headline: "Initiatives",
  intro: "Active ventures and initiatives focused on community impact, sales development, and building systems that create opportunity.",
  items: [
    {
      title: "Social Media Amber Alert",
      description: "Using the speed and reach of social platforms to help bridge the gap in missing persons awareness.",
      status: "Active",
      expandable: true,
      link: "https://www.facebook.com/ouramberalert/",
      fullContent: `Over six years ago, Adris Davis launched Social Media Amber Alert in response to a moment that exposed a critical gap.\n\nA family friend\u2019s daughter went missing\u2014and despite the urgency of the situation, no widespread alerts were being actively distributed. There was no real-time visibility, no amplification, and no system ensuring that her story reached enough people, fast enough.\n\nThat moment sparked action.\n\nSocial Media Amber Alert was created to use the speed and reach of social platforms to help bridge that gap\u2014sharing missing persons cases, increasing visibility, and mobilizing everyday people to stay aware and involved.\n\nWhat started as a single response has evolved into an ongoing initiative dedicated to:\n\n\u2022 Bringing attention to missing persons cases that may otherwise go unnoticed\n\u2022 Leveraging social media to expand reach beyond traditional alert systems\n\u2022 Creating urgency and awareness when time matters most\n\nThis project is rooted in one belief:\nVisibility can save lives.\n\nThrough consistent effort and commitment, Social Media Amber Alert continues to serve as a digital extension of awareness\u2014ensuring that when someone goes missing, their story has a chance to be seen.`,
    },
    {
      title: "Team Hustle \u2013 Coaching & Mentorship",
      description: "Production-driven mentorship that turns potential into consistent, top-level performance.",
      status: "Active",
      expandable: true,
      fullContent: `Team Hustle isn\u2019t motivation. It\u2019s production.\n\nUnder this brand, Adris Davis has developed sales professionals who don\u2019t just improve\u2014they separate from the pack. This is where average reps become top producers, and top producers become income leaders.\n\nWith over 20+ years in high-pressure sales environments, Adris built a system rooted in real-world execution\u2014not theory, not scripts copied off the internet, not recycled training programs.\n\nThis is field-tested dominance.\n\nHe has directly coached and mentored individuals who have gone on to become:\n\n\u2022 Six-figure earners\n\u2022 Multiple six-figure performers\n\u2022 Million-dollar producers\n\nAnd not one-time spikes\u2014consistent, repeatable production.\n\nRight now, he continues to mentor active sales professionals inside car dealerships who are:\n\n\u2022 Sitting at the top of their boards\n\u2022 Outperforming their peers month after month\n\u2022 Operating with a level of control most reps never reach\n\nThe difference is simple\u2014they think different, they move different, and they close different.\n\nThe Team Hustle Standard\n\nThis system is built on one principle:\nResults are the only metric that matters.\n\nCore focus:\n\n\u2022 Control the Sale \u2013 dominate the conversation, eliminate uncertainty\n\u2022 Psychological Positioning \u2013 understand how people actually make decisions\n\u2022 Objection Neutralization \u2013 remove resistance before it becomes a problem\n\u2022 Daily Production Discipline \u2013 no off days, no emotional swings\n\u2022 Income Scaling \u2013 turning skill into predictable, high-level earnings\n\nNo Excuses. No Guesswork.\n\nThis isn\u2019t for people looking to \u201cget better.\u201d\nThis is for people who are ready to produce at a level that forces attention.\n\nIf you\u2019re not at the top\u2014you\u2019re being outworked, out-positioned, or out-skilled.\n\nTeam Hustle fixes that.`,
    },
    { title: "Prestigious Travel Club Foundation", description: "A 501(c)(3) non-profit organization built on service\u2014supporting military families, feeding communities, and rewarding donors with premium travel certificates.", status: "Active" },
    {
      title: "Cars for Families Initiative",
      description: "Providing reliable transportation to families in need\u201420+ vehicles given away since 2020.",
      status: "Active",
      expandable: true,
      fullContent: `Since 2020, Adris Davis has quietly led a grassroots effort to support families in need through direct, practical action.\n\nWhat began as a simple idea\u2014help someone get back on their feet\u2014turned into the Cars for Families Initiative, a program focused on providing reliable transportation to individuals and families facing difficult circumstances.\n\nTo date, more than 20 vehicles have been given away.\n\nThese aren\u2019t luxury vehicles or showroom-ready cars. They are functional, dependable, and most importantly\u2014life-changing. For many recipients, access to a vehicle means the ability to:\n\n\u2022 Get to work consistently\n\u2022 Provide for their families\n\u2022 Regain independence and stability\n\nThis initiative was never about recognition. It was built on a simple principle:\n\nDo what you can, with what you have, when it matters most.\n\nEach vehicle represents more than transportation\u2014it represents opportunity, momentum, and a second chance.`,
    },
    { title: "Speaking & Workshop Inquiries", description: "Interested in having Adris speak at your event or organization? Get in touch.", status: "Available" },
  ],
};

export const assets = {
  headshots: [
    { label: "Primary Headshot", url: "https://customer-assets.emergentagent.com/job_wanderlust-club/artifacts/usgmm81i_image.png" },
    { label: "BMW Portrait", url: "https://customer-assets.emergentagent.com/job_wanderlust-club/artifacts/btsuczmj_image.png" },
    { label: "Cars Lifestyle", url: "https://customer-assets.emergentagent.com/job_wanderlust-club/artifacts/cahwv7hx_image.png" },
  ],
  logos: [
    { label: "Primary Logo (Dark)", url: "[Upload pending]" },
    { label: "Primary Logo (Light)", url: "[Upload pending]" },
  ],
  bookDescriptions: books.map(b => ({ title: b.title, amazonUrl: b.amazonUrl })),
  externalLinks: [
    { label: "Amazon Author Page", url: "https://www.amazon.com/stores/Adris-Davis/author/B0CD6FNMDY" },
    { label: "LinkedIn", url: "[Link pending]" },
    { label: "Speaking Inquiries", url: "[Link pending]" },
  ],
};
